import { useEffect, useState } from 'react';
import { ToastContainer } from 'react-bootstrap';
import Toast from 'react-bootstrap/Toast';
import './style.css';

function AlertNotification({ show, title, details, delay = 10000, variant = 'Primary', onClose }: IAlert) {
  const [showToast, setShowToast] = useState(false);
  const Icons = {
    Primary: " bi bi-exclamation-circle-fill",
    Success: " bi bi-check-circle-fill",
    Danger: " bi bi-x-circle-fill",
    Warning: " bi bi-exclamation-triangle-fill",
    Info: " bi bi-info-circle-fill"
  }

  useEffect(() => {
    setShowToast(show);

    const timer = setTimeout(() => {
      setShowToast(false);
    }, delay);

    return () => clearTimeout(timer);
  }, [show, delay]);

  return (
    <ToastContainer
      className="p-3 toast-ctn"
      position={'top-end'}
      style={{ zIndex: 9 }}
    >
      <Toast
        onClose={
          () => {
            setShowToast(false)
          if (onClose) {
            onClose()
          }
        }}
        show={showToast} 
        delay={delay} autohide
        bg="white"
        className={'toast-ctn-'+variant.toLowerCase()}
      >
        <Toast.Header />
        <Toast.Body>
          <div className='toast-icon-ctn'>
            <i className={"toast-icon toast-icon-" + variant.toLowerCase() + Icons[variant]}></i>
          </div>
          <div>
            <span className='toast-title'><b>{title}</b></span>
            <br/>
            <span>{details}</span>
          </div>          
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
}

export default AlertNotification;

export interface IAlert {
  show: boolean;
  title: string;
  details: string;
  delay?: number;
  variant?: colors;
  onClose?: () => void;
}

type colors = 'Primary' | 'Success' | 'Danger' | 'Warning' | 'Info';